import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import PhysicalPackageForm from './PhysicalPackageForm'

const PhysicalPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.physicalpackages.editPackage'}>
      <Edit>
        <PhysicalPackageForm />
      </Edit>
    </SectionWrapper>
  )
}

export default PhysicalPackageEdit
